<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/css/font-awesome.min.css';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/css/simple-line-icons.css';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
/* Import Vuetify Vue Styles */
@import '~vuetify/dist/vuetify.min.css';
</style>
<style lang="scss">
@import './scss/style';

#jsxc_windowList {
  bottom: 50px !important;
}

#jsxc_roster {
  top: 94px !important;
  bottom: 50px !important;
}

.v-application ol, .v-application ul {
    padding-left: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue